<template>
  <section id="energieausweis">
    <v-container>
      <v-row justify="center">
        <h2 class="section-title">{{ lang.energieausweis.caption }}</h2>
      </v-row>

      <v-row justify="center" class="ml-md-12 mt-4 mt-md-8 mt-lg-10">
        <v-col cols="12" md="5" lg="5" v-for="item in lang.energieausweis.items" :key="item.caption" class="mx-md-6">
          <div class="text-center text-md-start d-flex align-baseline justify-center justify-md-start">
            <v-icon size="40" class="primary-color" :icon="item.icon"></v-icon>
            <h3 class="text-h6 font-weight-medium mb-4 ml-2">{{ item.caption }}</h3>
          </div>

          <ul style="width: 100%; max-width: 400px; margin: 0 auto; padding: 0; text-align: left;"
              class="pl-6 mt-4 pl-md-0 ausweis-liste">
            <li class="mt-2" v-for="subitem in item.subitems" :key="subitem">{{ subitem }}</li>
          </ul>
        </v-col>

        <v-col cols="8" md="4" lg="4" xl="4" class="d-flex text-center justify-center mt-4">
          <v-img eager :src="energieeffizienzLogo"></v-img>
        </v-col>
      </v-row>

      <v-row justify="center">
        <v-col cols="12" md="8" class="text-center">
          <p class="font-weight-medium">{{ lang.energieausweis.subtext }}</p>
          <v-btn class="mt-6 text-white primary" size="large" href="#contact">{{ lang.energieausweis.button_to_contact_link }}</v-btn>
        </v-col>

      </v-row>
    </v-container>
  </section>
</template>

<style scoped>
@media (min-width: 1264px) {
  .v-container {
    max-width: 1200px;
  }
}

@media (min-width: 960px) {
  .ausweis-liste {
    max-width: unset !important;
  }
}
</style>

<script>
import lang from '@/lang/lang.js'

export default {
  data() {
    return {
      lang: lang,
      energieeffizienzLogo: '/images/Energieausweis/EE_EnergieeffizienzExperten_Logo.jpg',
    }
  }
}
</script>